import { StyleSheet } from 'react-native';

import { THEME } from '../../../../reactor/common';

const { COLOR, OFFSET } = THEME;

export default StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
  },

  image: {
    backgroundColor: COLOR.TRANSPARENT,
  },

  location: {
    position: 'absolute',
    bottom: OFFSET,
    left: OFFSET,
  },

  motion: {
    alignSelf: 'center',
    position: 'absolute',
    width: '85%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },

  rights: {
    position: 'absolute',
    bottom: OFFSET,
    left: OFFSET,
  },

  title: {
    textAlign: 'center',
  },

  titleWithImage: {
    marginBottom: '25%',
  },
});
